<template>
    <div>
        <div class="">
            <div class="box-header">
                <!-- tools box -->
                <!--<div class="pull-right box-tools">-->
                    <!--<button class="btn btn-primary btn-sm pull-right" data-widget="collapse" data-toggle="tooltip" title="" style="margin-right: 5px;margin-left: 5px;" data-original-title="Collapse"><i class="fa fa-minus"></i></button>-->
                    <!--<button class="btn  btn-primary btn-sm" data-widget="remove"><i class="fa fa-times"></i></button>-->
                <!--</div>&lt;!&ndash; /. tools &ndash;&gt;-->

                <i class="fa fa-file"></i>
                <h3 class="box-title">
                    Ajouter un fichier
                </h3>
            </div>
            <div class="box-body" style="display: block;">
                <form :action="linkOnUpload"
                      class="dropzone"
                      id="uploadFile"
                >
                    <div class="dz-message needsclick">
                        Glissez/déposez vos fichiers ici OU cliquez pour parcourir...<br>
                        <span class="note needsclick">{{ help }}</span>
                    </div>
                </form>
            </div><!-- /.box-body-->
            <div class="box-footer no-border" style="display: block;">
                <div class="row">

                </div><!-- /.row -->
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
    import Dropzone from 'dropzone'
    // Disabling autoDiscover, otherwise Dropzone will try to attach twice.
    Dropzone.autoDiscover = false;

    export default{
        props: {
            help: {
                default: "",
                type: String
            },
            fileType: {
                default: "",
                type: String
            },
            linkOnUpload: {
                type: String,
                default: ""
            }
        },
        data(){
            return {
                image: '',
                hovering: false,
                dropzoneObj: false
            }
        },
        methods: {
            initDropzone: function () {
                self = this
                this.dropzoneObj = new Dropzone("#uploadFile", {
                    url: self.linkOnUpload,
                    addRemoveLinks: true,
                    autoProcessQueue: false,
                    dictCancelUpload: "Annuler upload",
                    dictRemoveFile: "Supprimer ce fichier"
                })
                this.dropzoneObj.on("addedfile", function(file) {
                    if (self.dropzoneObj.files.length > 0)
                        self.$dispatch('filesAdded', true)
                    else
                        self.$dispatch('filesAdded', false)
                });
                this.dropzoneObj.on("removedfile", function(file) {
                    if (self.dropzoneObj.files.length > 0)
                        self.$dispatch('filesAdded', true)
                    else
                        self.$dispatch('filesAdded', false)
                });
            },
            onFileChange(e) {
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length) return;
                this.createImage(files[0]);
            },
            createImage(file) {
                var image = new Image();
                var reader = new FileReader();
                var vm = this;

                reader.onload = (e) => {
                    vm.image = e.target.result;
                };

                reader.readAsDataURL(file);
            },
            removeImage: function (e) {
                this.image = '';
            }
        },
        components: {
            //'other-component':OtherComponent,
        },
        ready: function () {
            if ((this.linkOnUpload == "" || typeof (this.linkOnUpload) == "undefined"))
                this.linkOnUpload = route('routeUploadFile')
            this.initDropzone()

        }
    }
</script>




// WEBPACK FOOTER //
// src/components/Communs/UploadFile.vue